module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Ruenenberg-faf3d66f5f9cf54cd2219819d0c49efe.svg";